// Mock data for Stark Hausmeisterservice Website

export const companyInfo = {
  name: "Stark Hausmeisterservice & Dienstleistungen",
  phone: "01522 7577500",
  whatsapp: "01522 7577500",
  email: "Info@starkdienstleistung.com",
  address: "Goldbergstraße 4",
  city: "89407 Dillingen an der Donau",
  rating: 5.0,
  reviewCount: 3,
  heroTitle: "Zuverlässiger Hausmeisterservice in Dillingen",
  heroSubtitle: "Schnell. Professionell. Stark.",
  heroDescription: "Ihr Ansprechpartner für Objektbetreuung, Reparaturen & Dienstleistungen.",
  aboutText: "Stark Hausmeisterservice steht für Zuverlässigkeit, Pünktlichkeit und saubere Arbeit. Als Ihr direkter Ansprechpartner in Dillingen und Umgebung bieten wir professionelle Hausmeisterdienstleistungen für private Hausbesitzer, Vermieter und Hausverwaltungen. Mit jahrelanger Erfahrung und höchstem Qualitätsanspruch sorgen wir dafür, dass Ihre Immobilie stets in bestem Zustand ist.",
  workingHours: "Mo-Fr: 08:00 - 18:00 Uhr\nSa: Nach Vereinbarung\nNotfallservice: 24/7"
};

export const services = [
  {
    id: 1,
    title: "Professioneller Winterdienst",
    description: "Zuverlässiger Räum- und Streudienst bei Schnee und Eis – für sichere Wege rund um Ihre Immobilie.",
    icon: "Snowflake",
    image: "https://images.unsplash.com/photo-1629818571630-5523061def62"
  },
  {
    id: 2,
    title: "Instandhaltungsarbeiten",
    description: "Schnelle und fachgerechte Wartung und Reparaturen – damit Ihre Immobilie stets in bestem Zustand bleibt.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1562259929-b4e1fd3aef09"
  },
  {
    id: 3,
    title: "Garten & Grundstückspflege",
    description: "Professionelle Pflege und Gestaltung Ihrer Außenanlagen – ganzjährig und zuverlässig.",
    icon: "Trees",
    image: "https://images.unsplash.com/photo-1594498653385-d5172c532c00"
  },
  {
    id: 4,
    title: "Hausmeisterarbeiten & technische Betreuung",
    description: "Umfassende Objektbetreuung und technische Verwaltung – Ihr direkter Ansprechpartner vor Ort.",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1635424824849-1b09bdcc55b1"
  },
  {
    id: 5,
    title: "Koordination & Kontrolle von Reparaturen",
    description: "Professionelles Management und Überwachung aller Reparaturarbeiten – für Ihre Sicherheit und Qualität.",
    icon: "ClipboardCheck",
    image: "https://images.unsplash.com/photo-1585421514284-efb74c2b69ba"
  },
  {
    id: 6,
    title: "Weitere Leistungen auf Anfrage",
    description: "Individuelle Dienstleistungen nach Ihren Bedürfnissen – sprechen Sie uns einfach an!",
    icon: "MessageSquarePlus",
    image: "https://images.unsplash.com/photo-1563453392212-326f5e854473"
  }
];

export const reviews = [
  {
    id: 1,
    author: "Katharina S.",
    rating: 5,
    date: "Vor 2 Monaten",
    text: "Perfekte Arbeit, sehr netter Kontakt, immer zuverlässig und freundlich – weiter so!"
  },
  {
    id: 2,
    author: "Michael R.",
    rating: 5,
    date: "Vor 3 Monaten",
    text: "Sehr professioneller Service! Termine werden eingehalten und die Qualität der Arbeit ist hervorragend."
  },
  {
    id: 3,
    author: "Sandra W.",
    rating: 5,
    date: "Vor 4 Monaten",
    text: "Endlich ein Hausmeisterservice, auf den man sich verlassen kann. Schnell, sauber und faire Preise!"
  }
];

export const trustBadges = [
  {
    icon: "Shield",
    title: "Zuverlässig & termintreu",
    description: "Pünktlich zu jedem Termin"
  },
  {
    icon: "Clock",
    title: "Schnelle Rückmeldung",
    description: "Antwort innerhalb 24h"
  },
  {
    icon: "Star",
    title: "5,0 Sterne Bewertung",
    description: "Zufriedene Kunden"
  }
];

export const faqs = [
  {
    question: "Welche Gebiete bedienen Sie?",
    answer: "Wir sind in Dillingen an der Donau und Umgebung tätig. Kontaktieren Sie uns gerne für Anfragen außerhalb dieser Region."
  },
  {
    question: "Bieten Sie einen Notfallservice an?",
    answer: "Ja, wir sind im Notfall 24/7 für Sie erreichbar. Rufen Sie uns einfach an!"
  },
  {
    question: "Wie schnell können Sie einen Termin anbieten?",
    answer: "In der Regel können wir innerhalb von 2-3 Werktagen einen Termin vereinbaren. Bei Notfällen oft am selben Tag."
  },
  {
    question: "Erstellen Sie kostenlose Angebote?",
    answer: "Ja, wir erstellen unverbindliche und kostenlose Angebote für alle unsere Dienstleistungen."
  }
];
